export const CALENDLY_LINK = "https://calendly.com/ivo-velocesoftware/30min";
